// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PresentationApprovalBadge_EmployeeFragment = { __typename?: 'Employee', id: string, newPresentationApprovalRequestCount: number };

export type PresentationApprovalBadgeCountQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type PresentationApprovalBadgeCountQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, employees?: Array<(
      { __typename?: 'Employee' }
      & PresentationApprovalBadge_EmployeeFragment
    )> | null } | null };

export type SetEmployeeLastViewedPresentationApprovalsAtMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type SetEmployeeLastViewedPresentationApprovalsAtMutation = { __typename?: 'Mutation', setEmployeeLastViewedPresentationApprovalsAt: (
    { __typename?: 'Employee' }
    & PresentationApprovalBadge_EmployeeFragment
  ) };

export const Operations = {
  Query: {
    PresentationApprovalBadgeCount: 'PresentationApprovalBadgeCount' as const
  },
  Mutation: {
    SetEmployeeLastViewedPresentationApprovalsAt: 'SetEmployeeLastViewedPresentationApprovalsAt' as const
  },
  Fragment: {
    PresentationApprovalBadge_Employee: 'PresentationApprovalBadge_Employee' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const PresentationApprovalBadge_EmployeeFragmentDoc = gql`
    fragment PresentationApprovalBadge_Employee on Employee {
  id
  newPresentationApprovalRequestCount
}
    `;
export const PresentationApprovalBadgeCountDocument = gql`
    query PresentationApprovalBadgeCount {
  currentUser {
    id
    employees {
      ...PresentationApprovalBadge_Employee
    }
  }
}
    ${PresentationApprovalBadge_EmployeeFragmentDoc}`;

/**
 * __usePresentationApprovalBadgeCountQuery__
 *
 * To run a query within a React component, call `usePresentationApprovalBadgeCountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePresentationApprovalBadgeCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePresentationApprovalBadgeCountQuery({
 *   variables: {
 *   },
 * });
 */
export function usePresentationApprovalBadgeCountQuery(baseOptions?: Apollo.QueryHookOptions<PresentationApprovalBadgeCountQuery, PresentationApprovalBadgeCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PresentationApprovalBadgeCountQuery, PresentationApprovalBadgeCountQueryVariables>(PresentationApprovalBadgeCountDocument, withFetchPolicyContext(options));
      }
export function usePresentationApprovalBadgeCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PresentationApprovalBadgeCountQuery, PresentationApprovalBadgeCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PresentationApprovalBadgeCountQuery, PresentationApprovalBadgeCountQueryVariables>(PresentationApprovalBadgeCountDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function usePresentationApprovalBadgeCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PresentationApprovalBadgeCountQuery, PresentationApprovalBadgeCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PresentationApprovalBadgeCountQuery, PresentationApprovalBadgeCountQueryVariables>(PresentationApprovalBadgeCountDocument, withFetchPolicyContext(options));
        }
export type PresentationApprovalBadgeCountQueryHookResult = ReturnType<typeof usePresentationApprovalBadgeCountQuery>;
export type PresentationApprovalBadgeCountLazyQueryHookResult = ReturnType<typeof usePresentationApprovalBadgeCountLazyQuery>;
export type PresentationApprovalBadgeCountSuspenseQueryHookResult = ReturnType<typeof usePresentationApprovalBadgeCountSuspenseQuery>;
export type PresentationApprovalBadgeCountQueryResult = Apollo.QueryResult<PresentationApprovalBadgeCountQuery, PresentationApprovalBadgeCountQueryVariables>;
export const SetEmployeeLastViewedPresentationApprovalsAtDocument = gql`
    mutation SetEmployeeLastViewedPresentationApprovalsAt {
  setEmployeeLastViewedPresentationApprovalsAt {
    ...PresentationApprovalBadge_Employee
  }
}
    ${PresentationApprovalBadge_EmployeeFragmentDoc}`;
export type SetEmployeeLastViewedPresentationApprovalsAtMutationFn = Apollo.MutationFunction<SetEmployeeLastViewedPresentationApprovalsAtMutation, SetEmployeeLastViewedPresentationApprovalsAtMutationVariables>;

/**
 * __useSetEmployeeLastViewedPresentationApprovalsAtMutation__
 *
 * To run a mutation, you first call `useSetEmployeeLastViewedPresentationApprovalsAtMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetEmployeeLastViewedPresentationApprovalsAtMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setEmployeeLastViewedPresentationApprovalsAtMutation, { data, loading, error }] = useSetEmployeeLastViewedPresentationApprovalsAtMutation({
 *   variables: {
 *   },
 * });
 */
export function useSetEmployeeLastViewedPresentationApprovalsAtMutation(baseOptions?: Apollo.MutationHookOptions<SetEmployeeLastViewedPresentationApprovalsAtMutation, SetEmployeeLastViewedPresentationApprovalsAtMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetEmployeeLastViewedPresentationApprovalsAtMutation, SetEmployeeLastViewedPresentationApprovalsAtMutationVariables>(SetEmployeeLastViewedPresentationApprovalsAtDocument, options);
      }
export type SetEmployeeLastViewedPresentationApprovalsAtMutationHookResult = ReturnType<typeof useSetEmployeeLastViewedPresentationApprovalsAtMutation>;
export type SetEmployeeLastViewedPresentationApprovalsAtMutationResult = Apollo.MutationResult<SetEmployeeLastViewedPresentationApprovalsAtMutation>;
export type SetEmployeeLastViewedPresentationApprovalsAtMutationOptions = Apollo.BaseMutationOptions<SetEmployeeLastViewedPresentationApprovalsAtMutation, SetEmployeeLastViewedPresentationApprovalsAtMutationVariables>;